import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  getBulkDynamicFields,
  getBulkDynamicFieldsRE,
  saveBulkDynamicFields,
} from "../../services/api/dynamic-fields-api";
import DynamicFieldBulkTable from "./DynamicFieldBulkTable";
import { getDashboardCarryOver } from "../../services/api/new-dashboard-api";

const DynamicFieldBulk = ({
  objectType,
  objectId,
  taskTypeId,
  projectTypeId,
  columnNamesNotNeeded,
  fetchData,
  hasProjectColumn,
  hasMemberColumn,
  hasDueDate,
  widgetName,
  selectedMember,
}) => {
  const [dynamicFieldsResult, setDynamicFieldsResult] = useState([]);
  const [techCarryOver, setTechCarryOver] = useState(false);
  const  obj = {
    objectType: objectType,
    objectId: objectId,
    taskTypeId: taskTypeId,
    projectTypeId: projectTypeId,
    taskIds: selectedMember ? selectedMember.WorklogTracker?.map(item => item.TaskId) : null,
  };
  const isRealEstate = widgetName === "RealEstate";

  useEffect(() => {
    if (isRealEstate) {
      fetchBulkDynamicFieldsRE();
    } else {
      fetchBulkDynamicFields();
    }
  }, []);

  const fetchBulkDynamicFields = async () => {
    let result = await getBulkDynamicFields(obj);
    setDynamicFieldsResult(result);
  };

  const fetchBulkDynamicFieldsRE = async () => {
    let result = await getBulkDynamicFieldsRE(obj);
    setDynamicFieldsResult(result.data);
  };

  const onSave = async (dynamicFieldsBulk) => {
    let response = await saveBulkDynamicFields(dynamicFieldsBulk);
    if (response.ok) {
      if (isRealEstate) {
        await fetchBulkDynamicFieldsRE();
      } else {
        await fetchBulkDynamicFields();
        setTechCarryOver(true);
      }
    } else {
      Promise.reject(response);
    }
    await fetchData();
  }

  useEffect(() => {
    if (techCarryOver) {
      getDashboardCarryOver();
      setTechCarryOver(false);
    }
  }, [techCarryOver]);

  return (
    dynamicFieldsResult?.length > 0 && (
      <DynamicFieldBulkTable
        originalData={dynamicFieldsResult}
        hasProjectColumn={hasProjectColumn}
        hasMemberColumn={hasMemberColumn}
        hasDueDate={hasDueDate}
        columnNamesNotNeeded={columnNamesNotNeeded}
        onSave={onSave}
        widgetName={widgetName}
      />
    )
  );
};

DynamicFieldBulk.propTypes = {
  objectType: PropTypes.string,
  objectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  taskTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  projectTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  columnNamesNotNeeded: PropTypes.arrayOf(PropTypes.string),
  fetchData: PropTypes.func,
  hasProjectColumn: PropTypes.bool,
  hasMemberColumn: PropTypes.bool,
  hasDueDate: PropTypes.bool,
  widgetName: PropTypes.string,
  selectedMember: PropTypes.shape({
    Id: PropTypes.number,
    WorklogTracker: PropTypes.array,
  }),
};

export default DynamicFieldBulk;
